import { Icon } from 'src/components/atoms/Icon';
import Text, { TextVariant } from 'src/components/atoms/Text';
import { ButtonNext, ButtonPrev, Container, OptionContainer, SelectContainer } from './styles';

interface IPaginationControlsProps {
  rowsPerPage: number;
  setPageSize: (size: number) => void;
  currentPage: number;
  totalPages: number;
  totalCount: number;
  fetchPreviousPage: () => void;
  fetchNextPage: () => void;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  isLoading?: boolean;
  itemDescriptor?: string;
}

const PaginationControls = ({
  rowsPerPage,
  setPageSize,
  currentPage,
  totalPages,
  totalCount,
  fetchPreviousPage,
  fetchNextPage,
  hasPreviousPage,
  hasNextPage,
  isLoading,
  itemDescriptor = 'items'
}: IPaginationControlsProps) => {
  return (
    <Container>
      <OptionContainer>
        <Text variant={TextVariant.small}>Rows per page:</Text>
        <SelectContainer value={rowsPerPage} onChange={(e) => setPageSize(Number(e.target.value))}>
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
        </SelectContainer>
      </OptionContainer>

      <Text variant={TextVariant.small}>
        Page {currentPage + 1} of {totalPages} | Total:&nbsp;{' '}
        <span data-testid="pagination-total-count">{totalCount}</span>&nbsp; {itemDescriptor}
      </Text>
      <div>
        <ButtonPrev
          onClick={() => fetchPreviousPage()}
          disabled={!hasPreviousPage || isLoading}
          hasPreviousPage={hasPreviousPage}
          aria-label="Previous"
          role="button"
        >
          <Icon icon="icon-arrow-left" />
        </ButtonPrev>

        <ButtonNext
          onClick={() => fetchNextPage()}
          disabled={!hasNextPage || isLoading}
          hasNextPage={hasNextPage}
          aria-label="Next"
          role="button"
        >
          <Icon icon="icon-arrow-right" />
        </ButtonNext>
      </div>
    </Container>
  );
};

export default PaginationControls;
